import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/providers/ApiContextProvider/ApiContextProvider';
import { DOCUMENTATION_KEY } from '@/api/constants/queryKeys';
import { handleCatch } from '@/api/helpers';
import { IGetDocTokenResponse } from '@/api/documentation/documentation.types';

export const useGetApiTutorialDocToken = () => {
  const { documentationApi } = useApi();

  const { mutate: fetchApiTutorialDocToken } = useMutation<IGetDocTokenResponse, Error, void>({
    mutationKey: [DOCUMENTATION_KEY],
    mutationFn: () => {
      return documentationApi.getApiTutorialDocToken().catch(reason => {
        return handleCatch(reason, `fetch api tutorial doc token`);
      });
    },
  });

  return {
    fetchApiTutorialDocToken,
  };
};
